var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-button',_vm._b({class:_vm.load ? 'disabled' : '',attrs:{"disabled":_vm.load,"icon":_vm.load ? 'fa fa-circle-o-notch fa-spin' : _vm.icon},on:{"button:click":_vm.handleClick}},'base-button',{
    tag: _vm.tag,
    type: _vm.type,
    size: _vm.size,
    textColor: _vm.textColor,
    nativeType: _vm.nativeType,
    text: _vm.text,
    outline: _vm.outline,
    rounded: _vm.rounded,
    iconOnly: _vm.iconOnly,
    block: _vm.block,
  },false),[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.btnLabel))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }